import axios from "axios";

let headers = {};

// if (localStorage.getItem('access_token')) {
//     headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`
// }

// const axiosInstance = axios.create({
//     baseURL: "https://dynamicwec.net/api/",
//     headers,
// })

const axiosInstance = axios.create({
  baseURL: "https://dwecbackend.dynamicwec.net/api/",
  headers,
});
export default axiosInstance;
